import { useEffect, useState } from 'react';

import Dropdown from '../components/Common/Dropdown';
import Tab from '../components/Common/Tab';
// import ApprovedTab from '../components/Features/CMS/DataEntrySpecialist/ApprovedTab';
import RejectedTab from '../components/Features/CMS/DataEntrySpecialist/RejectedTab';
import UnderReviewTab from '../components/Features/CMS/DataEntrySpecialist/UnderReviewTab';
import ApprovedTab from '../components/ReUsableComponents/CMS/ApprovedTab';
import {
  setSelectedQuestionType,
  setSelectedSection,
  setSelectedSourceName,
  setSelectedTopic,
  setSearchString
} from '../redux/Slices/CMS/DataReviewerSlice';
import { useAppDispatch, useAppSelector } from '../redux/store/hooks';
import {
  useFetchSourceNamesQuery,
  useLazyFetchTopicsBySectionQuery,
  useFetchQuestionTypesQuery,
  useGetAllCmsSectionsDataQuery
} from '../services/dataReviewerApi/dataReviewerApi';
import { useGetProgrammingTopicsQuery } from '../services/startTestAPI/startTestApi';

const CMSDataEntrySpecialistPage = () => {
  const [activeTabId, setActiveTabId] = useState('1');
  const {
    sourceNames,
    selectedSource,
    selectedSection,
    sectionsData,
    selectedTopic,
    topicsData,
    questionTypesData,
    selectedQuestionType,
    searchString,
    programmingTopicsData
  } = useAppSelector(state => state.root.dataReviewer);
  const [localSearch, setLocalSearch] = useState(searchString || '');
  const dispatch = useAppDispatch();
  const [getTopics] = useLazyFetchTopicsBySectionQuery();
  useFetchSourceNamesQuery({});
  useFetchQuestionTypesQuery({});
  useGetAllCmsSectionsDataQuery({});
  useGetProgrammingTopicsQuery({});

  const isMcqSelected = selectedQuestionType?.questionTypeName === 'MCQ';
  const isQuestionTypeSelected =
    selectedQuestionType?.questionTypeName === 'MCQ' ||
    selectedQuestionType?.questionTypeName === 'Programming';

  const tabs = [
    {
      value: 'Questions',
      id: '1',
      row: <UnderReviewTab />
    },
    {
      value: 'Rejected',
      id: '2',
      row: <RejectedTab />
    },
    {
      value: 'Approved',
      id: '3',
      row: <ApprovedTab />
    }
  ];

  const getTopicsFromAPI = async () => {
    try {
      const response = await getTopics({ sectionId: selectedSection.id });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTopicsFromAPI();
  }, [selectedSection]);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setSearchString(localSearch));
    }, 500);
    return () => clearTimeout(timer);
  }, [localSearch, dispatch]);

  return (
    <>
      <div className='relative z-30 mt-6 flex gap-2 px-6'>
        <div>
          <p className='block text-sm font-semibold leading-6'>Search</p>
          <div>
            <input
              type='text'
              placeholder='Search by question or question Id'
              value={localSearch}
              onChange={e => setLocalSearch(e.target.value)}
              className='relative mt-[6px] h-9 w-full appearance-none
                rounded-md border border-[#E3E5E9]
              bg-white
                py-1.5 pl-3 pr-10
                text-left text-blue_a12
                shadow-sm 
                ring-1 ring-inset ring-gray-300 
                focus:outline-none
              '
            />
          </div>
        </div>
        <Dropdown
          getOption={(option: any) => `${option?.sourceName}`}
          options={sourceNames}
          label='Source Name'
          value={selectedSource?.sourceName ?? ''}
          handleDropdownChange={e => dispatch(setSelectedSourceName(e))}
          width='w-[200px]'
          placeholder='Select Source Name'
        />
        <Dropdown
          getOption={(option: any) => `${option?.questionTypeName}`}
          options={questionTypesData}
          label='Question Type'
          value={selectedQuestionType?.questionTypeName ?? ''}
          handleDropdownChange={e => {
            dispatch(setSelectedTopic({}));
            dispatch(setSelectedSection({}));
            dispatch(setSelectedQuestionType(e));
          }}
          width='w-[100px}'
          placeholder='Select a Question Type'
        />
        {isMcqSelected && (
          <Dropdown
            getOption={(option: any) => `${option?.displayOnWebsite}`}
            options={sectionsData}
            label='Sections'
            value={selectedSection?.displayOnWebsite ?? ''}
            handleDropdownChange={e => {
              dispatch(setSelectedTopic({}));
              dispatch(setSelectedSection(e));
            }}
            width='w-[100px}'
            placeholder='Select a Section'
          />
        )}
        {isQuestionTypeSelected && (
          <Dropdown
            getOption={(option: any) => `${option?.topicName}`}
            options={!isMcqSelected ? programmingTopicsData : topicsData}
            label='Topics'
            value={selectedTopic?.topicName ?? ''}
            handleDropdownChange={e => dispatch(setSelectedTopic(e))}
            width='w-[100px}'
            placeholder='Select a Topic'
          />
        )}
      </div>

      <div className='relative z-0 mt-3 flex h-full w-full justify-center'>
        <Tab
          classes='px-4 py-1 text-[#4E5664);] text-sm'
          activeClass='border-b-[3px] border-[#0C604A] rounded-tl-lg rounded-tr-lg px-4 py-1 text-[#0C604A] text-sm font-medium'
          getActiveTab={tab => {
            setActiveTabId(tab);
          }}
          tabs={tabs}
        >
          {tabs.map((tab: any, index: number) => (
            <Tab.Body key={tab.id} id={tab.id}>
              {tab.row}
            </Tab.Body>
          ))}
        </Tab>
      </div>
    </>
  );
};

export default CMSDataEntrySpecialistPage;
